 
$(document).ready(function () {
  function closeAllCollageItems() {
    $("[data-collage-item]").removeClass("open").find(".collage-content").slideUp(200);
  }

  function openCollageItem($item) {
    if (!$item || !$item.length) return;
    closeAllCollageItems();
    $item.addClass("open");
    $item.find(".collage-content").slideDown(200);
  }

  function tryAutoOpenCollageItem() {
    var params = new URLSearchParams(window.location.search || "");
    var hash = (window.location.hash || "").replace("#", "").trim();
    var openId = (params.get("open_collage") || params.get("open_id") || params.get("open") || "").trim();
    var openName = (params.get("open_name") || params.get("open_collage_name") || "").trim();
    var triggerValue = openId || hash;
    var $target = $();

    if (triggerValue) {
      $target = $("#" + triggerValue);
      if (!$target.length) {
        $target = $('[data-collage-id="' + triggerValue + '"], [data-collage-name="' + triggerValue + '"]');
      }
    }

    if (!$target.length && openName) {
      $target = $('[data-collage-name="' + openName + '"]');
    }

    if ($target.length) {
      openCollageItem($target.first());
    }
  }

  $("[data-collage-toggle]").on("click", function () {
    let $item = $(this).closest("[data-collage-item]");
    if ($item.hasClass("open")) {
      $item.removeClass("open");
      $item.find(".collage-content").slideUp(200);
      return;
    }
    openCollageItem($item);
  });

  tryAutoOpenCollageItem();
});

 
  $(window).on("scroll", function () {
    $(".about-us-text-bg-image-box .common-box-container").each(function () {
      var t = $(window).scrollTop(),
        o = $(this).offset().top,
        e = $(this).outerHeight(),
        i = o - e;
      if (t + $(window).height() > o && t < o + e) {
        var s = -((t - i) * 0.12);
        767 > $(window).width() && (s = -((t - i) * 0.04)),
          $(this).css("background-position", "center " + s + "px");
      }
    });
  });



  $(document).ready(function(){
    $("footer input[name='contact[email]']").on("focus active", function(){
      $(this).closest(".t4s-newsletter__fields").addClass("active")
    })
    
    // 点击其他区域时移除active类
    $(document).on("click", function(e) {
      if(!$(e.target).closest(".t4s-newsletter__fields").length) {
        $(".t4s-newsletter__fields").removeClass("active");
      }
    })

  })

// 每秒检查支付按钮并添加SVG图标,30秒后停止检查
let checkCount = 0;
const checkInterval = setInterval(function() {
  if($("#more-payment-options-link").length > 0) {
    if($("#more-payment-options-link svg").length === 0) {
      $("#more-payment-options-link").prepend(`
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_2134_5081)">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.49219 4.98712L13.2433 1.66675L15.1651 4.99546L7.49219 4.98712Z" stroke="#333333" stroke-width="1.75"/>
            <path d="M1.66699 5.83333C1.66699 5.37308 2.04009 5 2.50033 5H17.5003C17.9606 5 18.3337 5.37308 18.3337 5.83333V17.5C18.3337 17.9602 17.9606 18.3333 17.5003 18.3333H2.50033C2.04009 18.3333 1.66699 17.9602 1.66699 17.5V5.83333Z" stroke="#333333" stroke-width="1.75"/>
            <path d="M14.6875 13.7499H18.3333V9.58325H14.6875C13.4794 9.58325 12.5 10.516 12.5 11.6666C12.5 12.8172 13.4794 13.7499 14.6875 13.7499Z" stroke="#333333" stroke-width="1.75"/>
            <path d="M18.333 6.875V16.875" stroke="#333333" stroke-width="1.75"/>
          </g>
          <defs>
            <clipPath id="clip0_2134_5081">
              <rect width="20" height="20" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      `);
    }
  }
  
  checkCount++;
  if(checkCount >= 30) {
    clearInterval(checkInterval);
  }
}, 1000);

 

 




function handleChangeVariant(currentVariant){
if(!currentVariant) return;

function showPrice(currentVariant){
console.log(currentVariant,"currentVariant");
let vid=currentVariant.id;
  $(`.variant-price-box-${vid}`).addClass("active");
  $(`.variant-price-box-${vid}`).siblings().removeClass("active");
  $(`.variant-image-box-${vid}`).addClass("active");
  $(`.variant-image-box-${vid}`).siblings().removeClass("active");
}
function handleInTheBox(currentVariant){
  // 判断logic_content_lists是否存在
  var logicContentList = window.logic_content_list || [];
  console.log(logicContentList,"logic_content_lists");
  if(logicContentList.length) {
    let option1 = currentVariant.option1;
    if(option1){
      let mactValue = null;
      for (let i = 0; i < logicContentList.length; i++) {
        let obj = logicContentList[i];
        if (obj.hasOwnProperty(option1)) {
          mactValue = obj[option1];
          break;
        }
      }
      console.log(mactValue,"mactValue");
      if (mactValue) {
        $(`.in-the-box-right-box .item`).hide();
        for(let i=0;i<mactValue.length;i++){
          let item=mactValue[i];
          console.log(item,"item");
          if(item == 0 || item == "0"){
            $(`.in-the-box-right-box .item-${i}`).hide();
          }else{
            $(`.in-the-box-right-box .item-${i} .num-box`).text(`x${item}`);
            $(`.in-the-box-right-box .item-${i}`).show();
          }
        }
      } else {
        // 如果没匹配上，则显示全部
        $(`.in-the-box-right-box .item`).show();
      }
    } else {
      // option1 不存在时也显示全部
      $(`.in-the-box-right-box .item`).show();
    }
  } else {
    // logic_content_list 不存在时也显示全部
    $(`.in-the-box-right-box .item`).show();
  }
}
showPrice(currentVariant);
handleInTheBox(currentVariant);
}



// 密码展示
$(document).ready(function(){
  $("body").on("click",".psw-option-box",function(){
    console.log($(this));
    $(this).toggleClass("active");
    $(this).closest('.t4s_field').find('input').attr("type", $(this).hasClass("active") ? "text" : "password");
  })
}) 
 


  $(document).ready(function(){
    function checkFormFilled($form) {
      // All visible, enabled input/textarea/select fields except hidden
      var $inputs = $form.find("input, textarea, select").filter(function() {
        var $el = $(this);
        // Exclude hidden fields and disabled fields
        if ($el.is(":hidden") || $el.is(":disabled")) return false;
        // If has 'required' attr, must be filled. If no 'required', still check
        return true;
      });
      var allFilled = true;
      $inputs.each(function(){
        var $el = $(this);
        if ($el.is('[type="checkbox"], [type="radio"]')) {
          // for checkbox/radio, at least one in group must be checked
          var name = $el.attr('name');
          // Only check for first in group
          if (name && $form.find('[name="'+name+'"]').length > 1) {
            var $group = $form.find('[name="'+name+'"]');
            if ($group.filter(':checked').length === 0) {
              allFilled = false;
              return false; // break
            }
          } else {
            if (!$el.is(':checked')) {
              allFilled = false;
              return false;
            }
          }
        } else if ($el.is('[type="file"]')) {
          if (!$el[0].files || $el[0].files.length === 0) {
            allFilled = false;
            return false;
          }
        } else {
          if (($el.val() || "").trim() === "") {
            allFilled = false;
            return false;
          }
        }
      });
      return allFilled;
    }

    function toggleAlreadyBoxForForm($form) {
      console.log($form,"$form");
      var $btns = $form.find('button[type="submit"], button.t4s_btn_submmit, button[type="button"].t4s_btn_submmit, button.t4s_btn_submmit');
      if (checkFormFilled($form)) {
        $btns.addClass('already-box');
      } else {
        $btns.removeClass('already-box');
      }
    }

    // 先循环计时器判断是否有#login_login-sidebar，再加载toggleAlreadyBoxForForm
    var loginSidebarCheckCount = 0;
    var loginSidebarCheckInterval = setInterval(function() {
      if ($('#login_login-sidebar').length > 0 || loginSidebarCheckCount > 30) {
        clearInterval(loginSidebarCheckInterval);
        $('form').each(function(){
          var $form = $(this);
          // Listen to input and change events on all fillable fields
          $form.on('input change', 'input, textarea, select', function() {
            toggleAlreadyBoxForForm($form);
          });
          // Also run on page load
          toggleAlreadyBoxForForm($form);
        });
      }
      loginSidebarCheckCount++;
    }, 100);

    function initSizeOptions($scope) {
      var $root = $scope && $scope.length ? $scope : $(document);
      $root.find('.is-t4s-size-option').each(function () {
        var $option = $(this);
        if ($option.find('.t4s-swatch__item.is--selected.is--size-extra').length) {
          $option.addClass('is--size-expanded');
          $option.find('[data-size-show-more]').remove();
        }
      });
    }

    $(document).on('click', '[data-size-show-more]', function (e) {
      e.preventDefault();
      var $btn = $(this);
      var $option = $btn.closest('.is-t4s-size-option');
      $option.addClass('is--size-expanded');
      $btn.remove();
    });

    initSizeOptions();
    $(document).on('variant:changed', function () {
      initSizeOptions();
    });
    $(document).on('shopify:section:load', function (e) {
      initSizeOptions($(e.target));
    });
  });
 